import { useTranslation } from 'react-i18next';
import * as Env from 'widget/env';

const useDate = (message: Env.Message, messageList: Env.Message[]) => {
  const { i18n } = useTranslation();

  const date = new Date(message.timestamp);
  const dateFormat = Intl.DateTimeFormat(i18n.resolvedLanguage).format(date);

  const index = messageList.findIndex(item => item.id == message.id);
  const prevMessage = messageList[index - 1] as Env.Message | undefined;
  if (!prevMessage) return dateFormat;

  const prevDate = new Date(prevMessage.timestamp);

  const prevDateFormat = Intl.DateTimeFormat(i18n.resolvedLanguage).format(
    prevDate,
  );

  if (dateFormat != prevDateFormat) return dateFormat;
  return null;
};

export default useDate;
